import Admin from './views/Admin'

const route = {
    exact: true,
    purePath: '/admin',
    path: '/:lang/admin/:page?/:action?/:id?',
    component: Admin
}

export default route